<template>
  <app-page-container title="کدهای 7-10">
    <template v-slot:header>
      <v-col cols="4" class="mr-n11">
        <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchTitle"
          class="mt-3"></v-text-field>
      </v-col>
      <v-col cols="4" class="flex items-end">
        <v-autocomplete :items="allZones" no-data-text="اطلاعاتی وجود ندارد" dense outlined rounded item-text="title"
          item-value="value" clearable clear-icon="mdi-close mdi-18px" append-icon="" multiple placeholder="ناحیه"
          autocomplete="off" class="current-mission-select" v-model="selectedZone"></v-autocomplete>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="2" class="text-left">
        <v-btn rounded color="darkColor" dark @click="enableAddEditFunction(1)" class="mt-3 normal-letter-spacing ml-3">
          <v-icon class="ml-1">mdi-plus mdi-18px</v-icon>
          افزودن کد
        </v-btn>
      </v-col>
    </template>
    <template v-slot:body>
      <v-row no-gutters class="background-main mx-2">
        <v-col cols="12">
          <v-card height="33vh" elevation="0" class="card-width">
            <v-card-text class="pa-0 pb-2">
              <v-row>
                <v-col cols="12">
                  <app-title-header>
                    <template v-slot:title>
                      <div class="d-flex align-center gap-2">
                        <span class="primary-color">کد های فعال 7-10</span>
                        <span class="primary-color">({{ all107sItems.length ?? 0 }})</span>
                        <v-icon color="darkColor" @click="getListOfAllActive107Codes">
                          mdi-refresh mdi-16px
                        </v-icon>
                      </div>
                    </template>
                  </app-title-header>
                  <template>
                    <v-data-table :headers="ambulance107InformationTableHeaders" :items="all107sItems"
                      :items-per-page="all107sItems.length" height="26.5vh" :search="searchTitle"
                      :hide-default-footer="true" multi-sort class="elevation-0 tt">
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-tooltip top v-if="item.isConfirmed == true">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-1" color="iconColor" style="cursor: pointer"
                              @click="showExtendTimeModal(item.id)" v-bind="attrs" v-on="on">
                              mdi-clock-time-four
                            </v-icon>
                          </template>
                          <span>تمدید زمان</span>
                        </v-tooltip>
                        <v-tooltip top v-if="item.isConfirmed == true">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer"
                              @click="showEndConfirmFunction(item.id)" v-bind="attrs" v-on="on">
                              mdi-car-emergency
                            </v-icon>
                          </template>
                          <span>10-10</span>
                        </v-tooltip>
                        <v-tooltip top v-if="!item.isConfirmed">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer"
                              @click="enableConfirmOrCancel(item.id, 1, item)" v-bind="attrs" v-on="on">
                              mdi-check-circle
                            </v-icon>
                          </template>
                          <span>تایید</span>
                        </v-tooltip>
                        <v-tooltip top v-if="!item.isConfirmed">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer"
                              @click="enableConfirmOrCancel(item.id, 2)" v-bind="attrs" v-on="on">
                              mdi-close-circle
                            </v-icon>
                          </template>
                          <span>لغو</span>
                        </v-tooltip>
                      </template>
                      <template v-slot:no-data>
                        <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                      </template>
                    </v-data-table>
                  </template>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row no-gutters class="px-2">
        <v-col cols="12" class="mt-4">
          <v-card elevation="0" height="40vh" class="time-10-7-main-card">
            <v-card-text class="pa-2">
              <v-row class="mb-4">
                <v-col cols="3" class="covered-position">
                  <div class="d-flex align-center gap-2">
                    <span class="current-mission-header-content">
                      اتمام زمان 7-10
                      <v-icon color="darkColor" @click="getListOfAllActiveAlarm107Codes">
                        mdi-refresh mdi-16px
                      </v-icon>
                    </span>
                  </div>
                </v-col>
                <v-col cols="3" class="covered-position2">
                  <v-text-field rounded placeholder="جستجو..." outlined v-model="allActiveAlarmSearchText" dense
                    class="current-mission-text-field"></v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <template>
                  <v-virtual-scroll :bench="4" :items="ambulance107AllActiveAlarmFilteredList" height="32vh"
                    item-height="79" class="scroller">
                    <template v-slot:default="{ item }">
                      <v-row :key="index">
                        <v-col cols="6">
                          <v-card elevation="0" height="8vh" class="all-active-alarm-card">
                            <v-row no-gutters>
                              <v-col cols="12" class="all-active-alarm-card-body">
                                <v-row no-gutters>
                                  <v-col cols="10" class="mt-6">
                                    <v-row>
                                      <v-col cols="3">
                                        <v-row>
                                          <v-spacer></v-spacer>
                                          <span class="all-active-alarm-card-body-items-title mr-3">
                                            کد آمبولانس:
                                          </span>
                                          <span class="all-active-alarm-card-body-items-value mr-2">
                                            {{ item?.item1?.ambulanceCode }}
                                          </span>
                                          <v-spacer></v-spacer>
                                        </v-row>
                                      </v-col>
                                      <v-col cols="5">
                                        <v-row>
                                          <v-spacer></v-spacer>
                                          <span class="all-active-alarm-card-body-items-title">
                                            زمان 10-7:
                                          </span>
                                          <span class="all-active-alarm-card-body-items-value mr-2">
                                            {{ item?.item1?.time }}
                                          </span>
                                          <v-spacer></v-spacer>
                                        </v-row>
                                      </v-col>
                                      <v-col cols="4">
                                        <v-row>
                                          <v-spacer></v-spacer>
                                          <span class="all-active-alarm-card-body-items-title">
                                            مدت زمان:
                                          </span>
                                          <v-chip color="background" small
                                            class="px-4 mr-2 all-active-alarm-card-body-items-value-time">
                                            {{ item?.item1?.duration }}
                                          </v-chip>
                                          <v-spacer></v-spacer>
                                        </v-row>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="2" class="mt-6">
                                    <v-row>
                                      <v-spacer></v-spacer>
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-icon color="iconColor" style="cursor: pointer"
                                            @click="showExtendTimeModal(item?.item1?.id)" v-bind="attrs" v-on="on">
                                            mdi-clock-time-four mdi-18px
                                          </v-icon>
                                        </template>
                                        <span>تمدید زمان</span>
                                      </v-tooltip>
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-icon class="mr-5" color="iconColor" style="cursor: pointer"
                                            @click="showEndConfirmFunction(item?.item1?.id)" v-bind="attrs" v-on="on">
                                            mdi-car-emergency mdi-18px
                                          </v-icon>
                                        </template>
                                        <span>10-10</span>
                                      </v-tooltip>
                                      <v-spacer></v-spacer>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-col>
                        <v-col v-if="item?.item2" cols="6">
                          <v-card elevation="0" height="8vh" class="all-active-alarm-card">
                            <v-row no-gutters>
                              <v-col cols="12" class="all-active-alarm-card-body">
                                <v-row no-gutters>
                                  <v-col cols="10" class="mt-6">
                                    <v-row no-gutters>
                                      <v-col cols="3">
                                        <v-row>
                                          <v-spacer></v-spacer>
                                          <span class="all-active-alarm-card-body-items-title mr-3">
                                            کد آمبولانس:
                                          </span>
                                          <span class="all-active-alarm-card-body-items-value mr-2">
                                            {{ item?.item2?.ambulanceCode }}
                                          </span>
                                          <v-spacer></v-spacer>
                                        </v-row>
                                      </v-col>
                                      <v-col cols="5">
                                        <v-row>
                                          <v-spacer></v-spacer>
                                          <span class="all-active-alarm-card-body-items-title">
                                            زمان 10-7:
                                          </span>
                                          <span class="all-active-alarm-card-body-items-value">
                                            {{ item?.item2?.time }}
                                          </span>
                                          <v-spacer></v-spacer>
                                        </v-row>
                                      </v-col>
                                      <v-col cols="4">
                                        <v-row>
                                          <v-spacer></v-spacer>
                                          <span class="all-active-alarm-card-body-items-title">
                                            مدت زمان:
                                          </span>
                                          <v-chip color="background" small
                                            class="px-4 mr-2 all-active-alarm-card-body-items-value-time">
                                            {{ item?.item2.duration }}
                                          </v-chip>
                                          <v-spacer></v-spacer>
                                        </v-row>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="2" class="mt-6">
                                    <v-row>
                                      <v-spacer></v-spacer>
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-icon color="iconColor" style="cursor: pointer"
                                            @click="showExtendTimeModal(item?.item2?.id)" v-bind="attrs" v-on="on">
                                            mdi-clock-time-four mdi-18px
                                          </v-icon>
                                        </template>
                                        <span>تمدید زمان</span>
                                      </v-tooltip>
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-icon class="mr-5" color="iconColor" style="cursor: pointer"
                                            @click="showEndConfirmFunction(item?.item2?.id)" v-bind="attrs" v-on="on">
                                            mdi-car-emergency mdi-18px
                                          </v-icon>
                                        </template>
                                        <span>10-10</span>
                                      </v-tooltip>
                                      <v-spacer></v-spacer>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-col>
                      </v-row>
                    </template>
                  </v-virtual-scroll>
                </template>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append>
      <section>
        <confirm-dialog ref="confirm">
          <v-row slot="action" no-gutters>
            <v-spacer></v-spacer>
            <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
              style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
              بله
            </v-btn>
            <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
              @click="confirmDialogCancelFunction()">
              خیر
            </v-btn>
          </v-row>
        </confirm-dialog>
        <v-dialog width="400" v-model="cancelModal" persistent>
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-close-circle</v-icon>
                  <span class="modal-title-text mr-2">لغو 10-7</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-5">
              <v-row>
                <v-col cols="12">
                  <v-textarea type="text" clearable clear-icon="mdi-close-circle-outline" v-model="cancelNote" dense
                    outlined rows="4" v-on:keyup.enter="showConfirmDialogFunction()" label="توضیحات" class="input-label"
                    prepend-inner-icon="mdi-text mdi-18px" tabindex="1"></v-textarea>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
                class="normal-letter-spacing px-12">
                ثبت
              </v-btn>
              <v-btn rounded color="darkColor" outlined @click="cancelCancelModal()"
                class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog width="400" v-model="confirmModal" persistent>
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-check-circle</v-icon>
                  <span class="modal-title-text mr-2">تایید 10-7</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-5">
              <v-row>
                <v-col cols="12">
                  <v-textarea type="text" clearable clear-icon="mdi-close-circle-outline" v-model="confirmNote" dense
                    outlined rows="4" v-on:keyup.enter="showConfirmDialogFunction()" label="توضیحات" class="input-label"
                    prepend-inner-icon="mdi-text mdi-18px" tabindex="1"></v-textarea>
                </v-col>
                <v-col cols="12" class="mt-n6">
                  <v-text-field type="text" clearable clear-icon="mdi-close-circle-outline" v-model="confirmHour" dense
                    outlined v-on:keyup.enter="showConfirmDialogFunction()" label="مدت زمان (ساعت)"
                    @keypress="isNumber($event)" class="input-label" prepend-inner-icon="mdi-clock-time-four mdi-18px"
                    tabindex="2"></v-text-field>
                </v-col>
                <v-col cols="12" class="mt-n6">
                  <v-text-field type="text" clearable clear-icon="mdi-close-circle-outline" v-model="confirmMinute"
                    dense @keypress="isNumber($event)" outlined v-on:keyup.enter="showConfirmDialogFunction()"
                    label="مدت زمان (دقیقه)" class="input-label" prepend-inner-icon="mdi-clock-time-four mdi-18px"
                    tabindex="3"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
                class="normal-letter-spacing px-12">
                ثبت
              </v-btn>
              <v-btn rounded color="darkColor" outlined @click="cancelConfirmModal()"
                class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog width="400" v-model="extendTimeModal" persistent>
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-clock-time-four</v-icon>
                  <span class="modal-title-text mr-2">تمدید زمان</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-5">
              <v-row>
                <v-col cols="12">
                  <v-text-field type="text" clearable clear-icon="mdi-close-circle-outline" v-model="extendHour" dense
                    outlined v-on:keyup.enter="showConfirmDialogFunction()" label="مدت زمان (ساعت)"
                    @keypress="isNumber($event)" class="input-label" prepend-inner-icon="mdi-clock-time-four mdi-18px"
                    tabindex="1"></v-text-field>
                </v-col>
                <v-col cols="12" class="mt-n6">
                  <v-text-field type="text" clearable clear-icon="mdi-close-circle-outline" v-model="extendMinute" dense
                    @keypress="isNumber($event)" outlined v-on:keyup.enter="showConfirmDialogFunction()"
                    label="مدت زمان (دقیقه)" class="input-label" prepend-inner-icon="mdi-clock-time-four mdi-18px"
                    tabindex="2"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
                class="normal-letter-spacing px-12">
                ثبت
              </v-btn>
              <v-btn rounded color="darkColor" outlined @click="cancelExtendTimetFunction()"
                class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog width="450" v-model="showAddEditModal" persistent>
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">{{ modalIcon }}</v-icon>
                  <span class="modal-title-text mr-2">{{ modalTitle }}</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-5">
              <v-row>
                <v-col cols="12">
                  <v-autocomplete :items="allPhonesForOther" no-data-text="اطلاعاتی وجود ندارد" tabindex="1" dense
                    outlined clearable clear-icon="mdi-close-circle-outline" item-text="code" item-value="id"
                    label="کد*" :autofocus="true" v-model="outOfServicePhone.phoneId" autocomplete="off"
                    prepend-inner-icon="mdi-ambulance mdi-18px" style="font-size: 11px !important"></v-autocomplete>
                </v-col>
                <v-col cols="12" class="mt-n6">
                  <v-textarea type="text" v-model="outOfServicePhone.note" dense clearable
                    clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="showConfirmDialogFunction()"
                    label="توضیحات" class="input-label" prepend-inner-icon="mdi-text mdi-18px" rows="4"
                    tabindex="2"></v-textarea>
                </v-col>
                <v-col cols="6" class="mt-n6">
                  <v-text-field type="text" clearable clear-icon="mdi-close-circle-outline" v-model="hour" dense
                    outlined v-on:keyup.enter="showConfirmDialogFunction()" label="مدت زمان (ساعت)"
                    @keypress="isNumber($event)" class="input-label" prepend-inner-icon="mdi-clock-time-four mdi-18px"
                    tabindex="3"></v-text-field>
                </v-col>
                <v-col cols="6" class="mt-n6">
                  <v-text-field type="text" clearable clear-icon="mdi-close-circle-outline" v-model="minute" dense
                    @keypress="isNumber($event)" outlined v-on:keyup.enter="showConfirmDialogFunction()"
                    label="مدت زمان (دقیقه)" class="input-label" prepend-inner-icon="mdi-clock-time-four mdi-18px"
                    tabindex="4"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
                class="normal-letter-spacing px-12">
                ثبت
              </v-btn>
              <v-btn rounded color="darkColor" outlined @click="cancelAddEditFunction()"
                class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </section>
      <section>
        <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
          :snakIcon="snakIcon"></alert-component>
      </section>
    </template>
  </app-page-container>
</template>
<script>
import confirmDialog from '@/components/ConfirmDialog.vue';
import AlertComponent from '@/components/AlertComponent.vue';
import AppPageContainer from '@/components/app/PageContainer.vue';
import AppTitleHeader from '@/components/app/TitleHeader.vue';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import OutOfServicePhoneMixin from '@/Mixins/800/OutOfServicePhoneMixin';
import Ambulance107sHelper from '@/Helpers/800/Ambulance107sHelper';
import PhoneMixin from '@/Mixins/BaseInformation/PhoneMixin';
import ZoneMixin from '@/Mixins/BaseInformation/ZoneMixin';
import UserNotificationMixin from '@/Mixins/800/userNotification.mixin';
export default {
  name: 'Ambulance107sView',
  title: 'کدهای 10-7',
  inject: ['load', 'tableTitleImage'],
  components: {
    confirmDialog,
    AlertComponent,
    AppPageContainer,
    AppTitleHeader,
  },
  mixins: [
    ShearedMixin,
    OutOfServicePhoneMixin,
    Ambulance107sHelper,
    snackBar,
    ShearedHelper,
    PhoneMixin,
    ZoneMixin,
    UserNotificationMixin,
  ],
  created() {
    this.$root.$refs.Ambulance107s = this;
    this.$mainSignalr.bus.$on('OutOfServiceCodes', this.fOutOfServiceCodes);
    this.$mobileSignalr.bus.$on('OutOfServiceCodes', this.fOutOfServiceCodes);
  },
  beforeDestroy() {
    this.$mainSignalr.bus.$off('OutOfServiceCodes', this.fOutOfServiceCodes);
    this.$mobileSignalr.bus.$off('OutOfServiceCodes', this.fOutOfServiceCodes);

    delete this.$root.$refs.Ambulance107s;
  },
  mounted() {
    this.mounteLoding();
    this.onMounted();
  },
  data() {
    return {
      tableImg: require('@/assets/images/LittleTable.png'),
      selectedZone: [],
    };
  },
  methods: {
    mounte: function () {
      this.getListOfAllActive107Codes();
      this.getListOfAllActiveAlarm107Codes();
    },
    fOutOfServiceCodes: function () {
      this.getListOfAllActive107Codes();
      this.getListOfAllActiveAlarm107Codes();
      this.getAllUserNotificationsOnSignal();
    },
    onMounted() {
      this.getAllZones();
    },
    filterByZone(items) {
      const filterdByZones = [];
      if (this.selectedZone.length == 0) {
        return items.filter((item) => {
          return item;
        });
      } else {
        for (const text of this.selectedZone) {
          for (const item of items) {
            if (item.zone.includes(text)) {
              filterdByZones.push(item);
            }
          }
        }
        return filterdByZones;
      }
    },
  },
  computed: {
    ambulance107AllActiveAlarmFilteredList() {
      let filterdBySearch = this.ambulance107AllActiveAlarm.filter((u) => {
        return u?.ambulanceCode.includes(this.allActiveAlarmSearchText);
      });
      filterdBySearch = this.convertIntoTwoColumnGroupList(filterdBySearch);
      return filterdBySearch;
    },

    all107sItems() {
      return this.filterByZone(this.ambulance107AllActive);
    },
  },
};
</script>
<style lang="scss">
.current-mission-select .v-input__control .v-input__slot {
  font-size: 12px;
}

.scroller {
  overflow-x: hidden !important;
}
</style>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.card-add-phoneNumber {
  border: 2px solid #cdcbcf !important;
}

.card-add-phoneNumber-items {
  margin-top: -7px !important;
}

.card-add-phoneNumber-items-text {
  color: #cdcbcf !important;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}

.time-10-7-main-card {
  border: 1px solid var(--light-color) !important;
  border-radius: 12px !important;
}

.covered-position {
  margin-top: -3.5vh !important;
}

.covered-position2 {
  margin-top: -4.2vh !important;
}

.current-mission-header-content {
  color: var(--dark-color) !important;
  background-image: linear-gradient(to bottom, var(--background-color) 50%, white 50%);
  padding-right: 20px !important;
  padding-left: 20px !important;
}

>>>.current-mission-text-field {
  position: absolute;
  width: 45vh !important;
}

>>>.current-mission-text-field fieldset {
  background: white !important;
}

>>>.current-mission-text-field .v-input__control .v-input__slot {
  min-height: 15px !important;
}

>>>.current-mission-text-field.v-input input {
  max-height: 30px !important;
}

.all-active-alarm-card {
  border-left: 1px solid var(--dark-color) !important;
  border-right: 1px solid var(--dark-color) !important;
  background: #fff5f3 !important;
  border-radius: 10px !important;
}

>>>.all-active-alarm-card-body {
  height: 7vh !important;
  background: white !important;
  margin-top: 0.5vh !important;
  border-radius: 10px !important;
}

.all-active-alarm-card-body-items-title {
  font-size: 14px;
  font-weight: 600;
  color: #212121;
}

.all-active-alarm-card-body-items-value {
  color: #333333;
  font-size: 13px;
  font-weight: 400;
}

.all-active-alarm-card-body-items-value-time {
  color: var(--dark-color) !important;
}

>>>.tt tbody tr:nth-of-type(even) {
  background-color: var(--background-color) !important;
}
</style>
